import Explainer from '../blocks';
import { useState, useEffect } from 'react';
import styles from './ScaleOperations.module.css';

const EXPLAINER_WIDTH = 662;
const EXPLAINER_HEIGHT = 460;

const CIRCLE_RADIUS_STROKED = 19.25;
const CIRCLE_RADIUS_FILL = 20.75;

const SPEED = 1;

const ScaleOperations = () => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => {
        let next = prev + direction;
        if (next > 4 || next < 0) {
          setDirection((d) => -d);
          next = prev - direction;
        }
        return next;
      });
    }, SPEED * 1000);

    return () => clearInterval(interval);
  }, [direction]);

  useEffect(() => {
    const scaleCircles = document.querySelectorAll(`[datascaleindex]`);

    scaleCircles != null &&
      scaleCircles.forEach((circle) => {
        circle.classList.remove(styles.active);

        if (circle.getAttribute('datascaleindex') <= index) {
          circle.classList.add(styles.active);
        }
      });
  }, [index]);

  return (
    <Explainer
      width={EXPLAINER_WIDTH}
      height={EXPLAINER_HEIGHT}
      className={styles.root}
    >
      <g className={styles.background}>
        <circle
          opacity="0.75"
          cx="140"
          cy="80"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 140 80)"
          stroke="#B73B55"
          strokeWidth="1.5"
          strokeDasharray="3 3"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="140"
          cy="140"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 140 140)"
          stroke="#B73B55"
          strokeWidth="1.5"
          strokeDasharray="3 3"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="80"
          cy="200"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 80 200)"
          stroke="#B73B55"
          strokeWidth="1.5"
          strokeDasharray="3 3"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="140"
          cy="260"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 140 260)"
          stroke="#B73B55"
          strokeWidth="1.5"
          strokeDasharray="3 3"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="20"
          cy="20"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 20 20)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="20"
          cy="80"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 20 80)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="20"
          cy="200"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 20 200)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="20"
          cy="260"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 20 260)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="140"
          cy="20"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 140 20)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="260"
          cy="20"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 260 20)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="260"
          cy="80"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 260 80)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="260"
          cy="140"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 260 140)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="260"
          cy="200"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 260 200)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="200"
          cy="260"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 200 260)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="200"
          cy="20"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 200 20)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="80"
          cy="80"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 80 80)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="80"
          cy="140"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 80 140)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="200"
          cy="140"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 200 140)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="140"
          cy="200"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 140 200)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="80"
          cy="260"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 80 260)"
          stroke="#B73B55"
          strokeWidth="1.5"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="80"
          cy="20"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 80 20)"
          stroke="#B73B55"
          strokeWidth="1.5"
          strokeDasharray="3 3"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="200"
          cy="80"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 200 80)"
          stroke="#B73B55"
          strokeWidth="1.5"
          strokeDasharray="3 3"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="200"
          cy="200"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 200 200)"
          stroke="#B73B55"
          strokeWidth="1.5"
          strokeDasharray="3 3"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="20"
          cy="140"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 20 140)"
          stroke="#B73B55"
          strokeWidth="1.5"
          strokeDasharray="3 3"
          fill="transparent"
        />
        <circle
          opacity="0.75"
          cx="260"
          cy="260"
          r={CIRCLE_RADIUS_STROKED}
          transform="rotate(-90 260 260)"
          stroke="#B73B55"
          strokeWidth="1.5"
          strokeDasharray="3 3"
          fill="transparent"
        />
      </g>
      <g className={styles.scaleCircles}>
        <circle
          cx="140"
          cy="80"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 140 80)"
          fill="#D47E90"
          datascaleindex={3}
        />
        <circle
          cx="140"
          cy="140"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 140 140)"
          fill="#D47E90"
          datascaleindex={2}
        />
        <circle
          cx="80"
          cy="200"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 80 200)"
          fill="#D47E90"
          datascaleindex={1}
        />
        <circle
          cx="140"
          cy="260"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 140 260)"
          fill="#D47E90"
          datascaleindex={2}
        />
        <circle
          cx="20"
          cy="20"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 20 20)"
          fill="#DB8F9F"
          datascaleindex={4}
        />
        <circle
          cx="20"
          cy="80"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 20 80)"
          fill="#DB8F9F"
          datascaleindex={3}
        />
        <circle
          cx="20"
          cy="200"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 20 200)"
          fill="#DB8F9F"
          datascaleindex={1}
        />
        <circle
          cx="20"
          cy="260"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 20 260)"
          fill="#DB8F9F"
          datascaleindex={0}
        />
        <circle
          cx="140"
          cy="20"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 140 20)"
          fill="#DB8F9F"
          datascaleindex={4}
        />
        <circle
          cx="260"
          cy="20"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 260 20)"
          fill="#DB8F9F"
          datascaleindex={4}
        />
        <circle
          cx="260"
          cy="80"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 260 80)"
          fill="#DB8F9F"
          datascaleindex={4}
        />
        <circle
          cx="260"
          cy="140"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 260 140)"
          fill="#DB8F9F"
          datascaleindex={4}
        />
        <circle
          cx="260"
          cy="200"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 260 200)"
          fill="#DB8F9F"
          datascaleindex={4}
        />
        <circle
          cx="200"
          cy="260"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 200 260)"
          fill="#DB8F9F"
          datascaleindex={3}
        />
        <circle
          cx="200"
          cy="20"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 200 20)"
          fill="#DB8F9F"
          datascaleindex={4}
        />
        <circle
          cx="80"
          cy="80"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 80 80)"
          fill="#DB8F9F"
          datascaleindex={3}
        />
        <circle
          cx="80"
          cy="140"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 80 140)"
          fill="#DB8F9F"
          datascaleindex={2}
        />
        <circle
          cx="200"
          cy="140"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 200 140)"
          fill="#DB8F9F"
          datascaleindex={3}
        />
        <circle
          cx="140"
          cy="200"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 140 200)"
          fill="#DB8F9F"
          datascaleindex={2}
        />
        <circle
          cx="80"
          cy="260"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 80 260)"
          fill="#DB8F9F"
          datascaleindex={1}
        />
        <circle
          cx="80"
          cy="20"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 80 20)"
          fill="#D47E90"
          datascaleindex={4}
        />
        <circle
          cx="200"
          cy="80"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 200 80)"
          fill="#D47E90"
          datascaleindex={3}
        />
        <circle
          cx="200"
          cy="200"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 200 200)"
          fill="#D47E90"
          datascaleindex={3}
        />
        <circle
          cx="20"
          cy="140"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 20 140)"
          fill="#D47E90"
          datascaleindex={2}
        />
        <circle
          cx="260"
          cy="260"
          r={CIRCLE_RADIUS_FILL}
          transform="rotate(-90 260 260)"
          fill="#D47E90"
          datascaleindex={4}
        />
      </g>
    </Explainer>
  );
};

export default ScaleOperations;
